import { render, staticRenderFns } from "./PartsOnOrder.vue?vue&type=template&id=6b4c6fe8"
import script from "./PartsOnOrder.vue?vue&type=script&lang=js"
export * from "./PartsOnOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports